import {
  FabricDesign,
  Rail,
  ServerGroup,
  SwitchGroup
} from "src/gen/schema/models/fabric_design";

export const getRailById = (
  fabricDesign: FabricDesign,
  railId: string
): Rail | undefined =>
  fabricDesign.railGroups
    .flatMap((group) => group.rails)
    .find((rail) => rail.baseData?.id === railId);

export const getSwitchGroupByNodeId = (
  fabricDesign: FabricDesign,
  nodeId: string
): SwitchGroup | undefined => {
  return fabricDesign.tiers
    .flatMap((tier) => tier.switchGroups)
    .find((switchGroup) =>
      switchGroup.hwSets.some((hwSet) =>
        hwSet.nodes.some((node) => node.id === nodeId)
      )
    );
};

export const getServerGroupByNodeId = (
  fabricDesign: FabricDesign,
  nodeId: string
): ServerGroup | undefined => {
  return fabricDesign.tiers
    .flatMap((tier) => tier.serverGroups)
    .find((switchGroup) =>
      switchGroup.hwSets.some((hwSet) =>
        hwSet.nodes.some((node) => node.id === nodeId)
      )
    );
};
